import {
  getCompanyPromotions,
  getCompanyPromotion,
  createCompanyPromotion,
  updateCompanyPromotion,
  updateCompanyPromotionStatus,
  deleteCompanyPromotion,
  getCities,
  getInitiators,
  createInitiator,
  uploadBanner,
  uploadFile,
  validateFile,
  createPromotionButton,
  getButtons
} from '../../api/companyPromotions';

// Action types
export const COMPANY_PROMOTIONS_ACTIONS = {
  // Promotions list
  GET_PROMOTIONS_REQUEST: 'GET_PROMOTIONS_REQUEST',
  GET_PROMOTIONS_SUCCESS: 'GET_PROMOTIONS_SUCCESS',
  GET_PROMOTIONS_FAILURE: 'GET_PROMOTIONS_FAILURE',
  
  // Single promotion
  GET_PROMOTION_REQUEST: 'GET_PROMOTION_REQUEST',
  GET_PROMOTION_SUCCESS: 'GET_PROMOTION_SUCCESS',
  GET_PROMOTION_FAILURE: 'GET_PROMOTION_FAILURE',
  
  // Create promotion
  CREATE_PROMOTION_REQUEST: 'CREATE_PROMOTION_REQUEST',
  CREATE_PROMOTION_SUCCESS: 'CREATE_PROMOTION_SUCCESS',
  CREATE_PROMOTION_FAILURE: 'CREATE_PROMOTION_FAILURE',
  
  // Update promotion
  UPDATE_PROMOTION_REQUEST: 'UPDATE_PROMOTION_REQUEST',
  UPDATE_PROMOTION_SUCCESS: 'UPDATE_PROMOTION_SUCCESS',
  UPDATE_PROMOTION_FAILURE: 'UPDATE_PROMOTION_FAILURE',
  
  // Update promotion status
  UPDATE_PROMOTION_STATUS_REQUEST: 'UPDATE_PROMOTION_STATUS_REQUEST',
  UPDATE_PROMOTION_STATUS_SUCCESS: 'UPDATE_PROMOTION_STATUS_SUCCESS',
  UPDATE_PROMOTION_STATUS_FAILURE: 'UPDATE_PROMOTION_STATUS_FAILURE',
  
  // Delete promotion
  DELETE_PROMOTION_REQUEST: 'DELETE_PROMOTION_REQUEST',
  DELETE_PROMOTION_SUCCESS: 'DELETE_PROMOTION_SUCCESS',
  DELETE_PROMOTION_FAILURE: 'DELETE_PROMOTION_FAILURE',
  
  // Cities
  GET_CITIES_REQUEST: 'GET_CITIES_REQUEST',
  GET_CITIES_SUCCESS: 'GET_CITIES_SUCCESS',
  GET_CITIES_FAILURE: 'GET_CITIES_FAILURE',
  
  // Initiators
  GET_INITIATORS_REQUEST: 'GET_INITIATORS_REQUEST',
  GET_INITIATORS_SUCCESS: 'GET_INITIATORS_SUCCESS',
  GET_INITIATORS_FAILURE: 'GET_INITIATORS_FAILURE',
  
  CREATE_INITIATOR_REQUEST: 'CREATE_INITIATOR_REQUEST',
  CREATE_INITIATOR_SUCCESS: 'CREATE_INITIATOR_SUCCESS',
  CREATE_INITIATOR_FAILURE: 'CREATE_INITIATOR_FAILURE',
  
  // File upload
  UPLOAD_BANNER_REQUEST: 'UPLOAD_BANNER_REQUEST',
  UPLOAD_BANNER_SUCCESS: 'UPLOAD_BANNER_SUCCESS',
  UPLOAD_BANNER_FAILURE: 'UPLOAD_BANNER_FAILURE',
  
  UPLOAD_FILE_REQUEST: 'UPLOAD_FILE_REQUEST',
  UPLOAD_FILE_SUCCESS: 'UPLOAD_FILE_SUCCESS',
  UPLOAD_FILE_FAILURE: 'UPLOAD_FILE_FAILURE',
  
  VALIDATE_FILE_REQUEST: 'VALIDATE_FILE_REQUEST',
  VALIDATE_FILE_SUCCESS: 'VALIDATE_FILE_SUCCESS',
  VALIDATE_FILE_FAILURE: 'VALIDATE_FILE_FAILURE',
  
  // Buttons
  CREATE_BUTTON_REQUEST: 'CREATE_BUTTON_REQUEST',
  CREATE_BUTTON_SUCCESS: 'CREATE_BUTTON_SUCCESS',
  CREATE_BUTTON_FAILURE: 'CREATE_BUTTON_FAILURE',
  
  GET_BUTTONS_REQUEST: 'GET_BUTTONS_REQUEST',
  GET_BUTTONS_SUCCESS: 'GET_BUTTONS_SUCCESS',
  GET_BUTTONS_FAILURE: 'GET_BUTTONS_FAILURE',
  
  // Clear data
  CLEAR_PROMOTION_DATA: 'CLEAR_PROMOTION_DATA',
  CLEAR_ERRORS: 'CLEAR_ERRORS'
};

// Action creators
export const getPromotions = (params = {}) => async (dispatch) => {
  dispatch({ type: COMPANY_PROMOTIONS_ACTIONS.GET_PROMOTIONS_REQUEST });
  try {
    const response = await getCompanyPromotions(params);
    dispatch({
      type: COMPANY_PROMOTIONS_ACTIONS.GET_PROMOTIONS_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    dispatch({
      type: COMPANY_PROMOTIONS_ACTIONS.GET_PROMOTIONS_FAILURE,
      payload: error.response?.data?.message || 'Ошибка при загрузке акций'
    });
  }
};

export const getPromotion = (id) => async (dispatch) => {
  dispatch({ type: COMPANY_PROMOTIONS_ACTIONS.GET_PROMOTION_REQUEST });
  try {
    const response = await getCompanyPromotion(id);
    dispatch({
      type: COMPANY_PROMOTIONS_ACTIONS.GET_PROMOTION_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    dispatch({
      type: COMPANY_PROMOTIONS_ACTIONS.GET_PROMOTION_FAILURE,
      payload: error.response?.data?.message || 'Ошибка при загрузке акции'
    });
  }
};

export const createPromotion = (data) => async (dispatch) => {
  dispatch({ type: COMPANY_PROMOTIONS_ACTIONS.CREATE_PROMOTION_REQUEST });
  try {
    const response = await createCompanyPromotion(data);
    dispatch({
      type: COMPANY_PROMOTIONS_ACTIONS.CREATE_PROMOTION_SUCCESS,
      payload: response.data
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: COMPANY_PROMOTIONS_ACTIONS.CREATE_PROMOTION_FAILURE,
      payload: error.response?.data?.message || 'Ошибка при создании акции'
    });
    throw error;
  }
};

export const updatePromotion = (id, data) => async (dispatch) => {
  dispatch({ type: COMPANY_PROMOTIONS_ACTIONS.UPDATE_PROMOTION_REQUEST });
  try {
    const response = await updateCompanyPromotion(id, data);
    dispatch({
      type: COMPANY_PROMOTIONS_ACTIONS.UPDATE_PROMOTION_SUCCESS,
      payload: response.data
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: COMPANY_PROMOTIONS_ACTIONS.UPDATE_PROMOTION_FAILURE,
      payload: error.response?.data?.message || 'Ошибка при обновлении акции'
    });
    throw error;
  }
};

export const updatePromotionStatus = (id, status) => async (dispatch) => {
  dispatch({ type: COMPANY_PROMOTIONS_ACTIONS.UPDATE_PROMOTION_STATUS_REQUEST });
  try {
    const response = await updateCompanyPromotionStatus(id, status);
    dispatch({
      type: COMPANY_PROMOTIONS_ACTIONS.UPDATE_PROMOTION_STATUS_SUCCESS,
      payload: response.data
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: COMPANY_PROMOTIONS_ACTIONS.UPDATE_PROMOTION_STATUS_FAILURE,
      payload: error.response?.data?.message || 'Ошибка при обновлении статуса акции'
    });
    throw error;
  }
};

export const deletePromotion = (id) => async (dispatch) => {
  dispatch({ type: COMPANY_PROMOTIONS_ACTIONS.DELETE_PROMOTION_REQUEST });
  try {
    await deleteCompanyPromotion(id);
    dispatch({
      type: COMPANY_PROMOTIONS_ACTIONS.DELETE_PROMOTION_SUCCESS,
      payload: id
    });
  } catch (error) {
    dispatch({
      type: COMPANY_PROMOTIONS_ACTIONS.DELETE_PROMOTION_FAILURE,
      payload: error.response?.data?.message || 'Ошибка при удалении акции'
    });
    throw error;
  }
};

export const getCitiesList = () => async (dispatch) => {
  dispatch({ type: COMPANY_PROMOTIONS_ACTIONS.GET_CITIES_REQUEST });
  try {
    const response = await getCities();
    dispatch({
      type: COMPANY_PROMOTIONS_ACTIONS.GET_CITIES_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    dispatch({
      type: COMPANY_PROMOTIONS_ACTIONS.GET_CITIES_FAILURE,
      payload: error.response?.data?.message || 'Ошибка при загрузке городов'
    });
  }
};

export const getInitiatorsList = () => async (dispatch) => {
  dispatch({ type: COMPANY_PROMOTIONS_ACTIONS.GET_INITIATORS_REQUEST });
  try {
    const response = await getInitiators();
    dispatch({
      type: COMPANY_PROMOTIONS_ACTIONS.GET_INITIATORS_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    dispatch({
      type: COMPANY_PROMOTIONS_ACTIONS.GET_INITIATORS_FAILURE,
      payload: error.response?.data?.message || 'Ошибка при загрузке инициаторов'
    });
  }
};

export const createInitiatorAction = (data) => async (dispatch) => {
  dispatch({ type: COMPANY_PROMOTIONS_ACTIONS.CREATE_INITIATOR_REQUEST });
  try {
    const response = await createInitiator(data);
    dispatch({
      type: COMPANY_PROMOTIONS_ACTIONS.CREATE_INITIATOR_SUCCESS,
      payload: response.data
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: COMPANY_PROMOTIONS_ACTIONS.CREATE_INITIATOR_FAILURE,
      payload: error.response?.data?.message || 'Ошибка при создании инициатора'
    });
    throw error;
  }
};

export const uploadBannerAction = (file, lang) => async (dispatch) => {
  dispatch({ type: COMPANY_PROMOTIONS_ACTIONS.UPLOAD_BANNER_REQUEST });
  try {
    const response = await uploadBanner(file, lang);
    dispatch({
      type: COMPANY_PROMOTIONS_ACTIONS.UPLOAD_BANNER_SUCCESS,
      payload: response.data
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: COMPANY_PROMOTIONS_ACTIONS.UPLOAD_BANNER_FAILURE,
      payload: error.response?.data?.message || 'Ошибка при загрузке баннера'
    });
    throw error;
  }
};

export const uploadFileAction = (formData) => async (dispatch) => {
  dispatch({ type: COMPANY_PROMOTIONS_ACTIONS.UPLOAD_FILE_REQUEST });
  try {
    const response = await uploadFile(formData);
    dispatch({
      type: COMPANY_PROMOTIONS_ACTIONS.UPLOAD_FILE_SUCCESS,
      payload: response.data
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: COMPANY_PROMOTIONS_ACTIONS.UPLOAD_FILE_FAILURE,
      payload: error.response?.data?.message || 'Ошибка при загрузке файла'
    });
    throw error;
  }
};

export const validateFileAction = (fileId) => async (dispatch) => {
  dispatch({ type: COMPANY_PROMOTIONS_ACTIONS.VALIDATE_FILE_REQUEST });
  try {
    const response = await validateFile(fileId);
    dispatch({
      type: COMPANY_PROMOTIONS_ACTIONS.VALIDATE_FILE_SUCCESS,
      payload: response.data
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: COMPANY_PROMOTIONS_ACTIONS.VALIDATE_FILE_FAILURE,
      payload: error.response?.data?.message || 'Ошибка при валидации файла'
    });
    throw error;
  }
};

export const createButtonAction = (data) => async (dispatch) => {
  dispatch({ type: COMPANY_PROMOTIONS_ACTIONS.CREATE_BUTTON_REQUEST });
  try {
    const response = await createPromotionButton(data);
    dispatch({
      type: COMPANY_PROMOTIONS_ACTIONS.CREATE_BUTTON_SUCCESS,
      payload: response.data
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: COMPANY_PROMOTIONS_ACTIONS.CREATE_BUTTON_FAILURE,
      payload: error.response?.data?.message || 'Ошибка при создании кнопки'
    });
    throw error;
  }
};

export const getButtonsList = () => async (dispatch) => {
  dispatch({ type: COMPANY_PROMOTIONS_ACTIONS.GET_BUTTONS_REQUEST });
  try {
    const response = await getButtons();
    dispatch({
      type: COMPANY_PROMOTIONS_ACTIONS.GET_BUTTONS_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    dispatch({
      type: COMPANY_PROMOTIONS_ACTIONS.GET_BUTTONS_FAILURE,
      payload: error.response?.data?.message || 'Ошибка при загрузке кнопок'
    });
  }
};

export const clearPromotionData = () => ({
  type: COMPANY_PROMOTIONS_ACTIONS.CLEAR_PROMOTION_DATA
});

export const clearErrors = () => ({
  type: COMPANY_PROMOTIONS_ACTIONS.CLEAR_ERRORS
});
